<template>
  <a-card>
    <div class="cardBody">
      <a-form>
        <div>
          <base-input :label="`Password`">
            <a-input
              :type="passwordType"
              placeholder="Password"
              v-model="formData.password"
              @input="onPasswordInput"
            >
              <template #addonAfter>
                <i class="fa fa-eye" aria-hidden="true" @click="viewPassword" />
              </template>
            </a-input>
            <br />
            <br />
            <div class="condition-text">
              Password must contain:
              <ul>
                <li
                  :class="[
                    'condition-text',
                    {
                      passed:
                        $v.formData.password.minLength &&
                        $v.formData.password.maxLength,
                    },
                  ]"
                >
                  <div>Should be 8-30 characters long</div>
                </li>
                <li
                  :class="[
                    'condition-text',
                    {
                      passed: $v.formData.password.alphaNumSpecial,
                    },
                  ]"
                >
                  <div>Should contain alphabetical character</div>
                </li>
                <li
                  :class="[
                    'condition-text',
                    {
                      passed: $v.formData.password.hasNum,
                    },
                  ]"
                >
                  <div>Should contain Numeric character</div>
                </li>
                <li
                  :class="[
                    'condition-text',
                    {
                      passed: $v.formData.password.hasSpe,
                    },
                  ]"
                >
                  <div>Should contain special character (!@#$%^&*)</div>
                </li>
              </ul>
            </div>
          </base-input>
          <base-input :label="`Re Enter Password`">
            <a-input
              :type="rePasswordType"
              placeholder="Re Enter Password"
              v-model="formData.repassword"
              @input="onPasswordInput"
            >
            <template #addonAfter>
              <i class="fa fa-eye" aria-hidden="true" @click="viewConPassword" />
            </template>
            </a-input>
            <div v-if="$v.formData.repassword.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.repassword.required">
                Field is required
              </div>
              <div class="error" v-if="!$v.formData.repassword.isSame">
                Passwords must match
              </div>
            </div>
          </base-input>
        </div>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

function conditionalMinLength(length) {
  return function (value) {
    // If empty, skip validation
    if (!value) return false;
    return minLength(length)(value);
  };
}

function alphaNumSpecial(value) {
  if (!value) return false;
  return /^[A-Za-z0-9!@#$%^&*]+$/.test(value);
}

export default {
  props: {
    data: {
      type: Object,
    },
  },
  name: 'SetPassword',
  data() {
    return {
      formData: {
        password: null,
        repassword: null,
      },
      passwordType: 'password',
      rePasswordType: 'password',
      minLength: 8,
      maxLength: 30,
    };
  },
  validations() {
    const validation = {
      formData: {
        password: {
          required,
          minLength: conditionalMinLength(this.minLength),
          maxLength: maxLength(this.maxLength),
          alphaNumSpecial: (value) => alphaNumSpecial(value),
          hasNum: (value) => /\d/.test(value) && !/^\d+$/.test(value),
          hasSpe: (value) => {
            if (typeof value !== 'string') return false;
            const specialChars = '!@#$%^&*';
            const escapedChars = specialChars.replace(
              /[-[\]/{}()*+?.\\^$|]/g,
              '\\$&'
            );
            const containsSpecialChar = new RegExp(`[${escapedChars}]`).test(
              value
            );

            return containsSpecialChar;
          },
        },
        repassword: {
          required,
          isSame: (value) => this.formData.password === value,
        },
      },
    };
    return validation;
  },
  methods: {
    viewPassword() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },
    viewConPassword() {
      if (this.rePasswordType === 'password') {
        this.rePasswordType = 'text';
      } else {
        this.rePasswordType = 'password';
      }
    },
    onPasswordInput() {
      this.$v.formData.$touch(); // So the validations react as you type
      this.$emit('password-updated'); // Notify the parent
    },
    validate() {
      console.log('Validate data');
      this.$v.formData.$touch();
    },
  },
};
</script>

<style scoped>
.condition-text {
  color: gray;
}
.passed {
  color: green;
}
</style>
